export default function SupportIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 200 200"
      fill="none"
      style={{ stroke: "black", strokeWidth: "8px" }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M176.75 200H21.9252C13.7766 200 7.06787 193.289 7.06787 185.14V84.0015C7.06787 78.7289 9.46358 73.9365 13.2982 70.5812L96.701 1.07849C98.139 -0.359497 100.537 -0.359497 102.454 1.07849L185.857 70.5812C189.691 73.9365 192.087 78.7289 192.087 84.0015V185.14C191.608 193.289 184.898 200 176.75 200ZM99.5774 10.1853L19.0511 77.2913C17.1338 78.7293 16.1747 81.6048 16.1747 84.0015V185.14C16.1747 188.496 19.0497 191.372 22.405 191.372H177.23C180.585 191.372 183.46 188.496 183.46 185.14V84.0015C183.46 81.6048 182.501 79.2086 180.584 77.2913L99.5774 10.1853Z"
        fill="#129219"
      />
      <path
        d="M186.816 193.29C185.857 193.29 184.898 192.811 183.939 192.331L99.577 118.994L15.2146 192.331C13.2973 193.769 10.4223 193.769 8.98428 191.852C7.54629 189.934 7.54676 187.059 9.46408 185.621L96.7005 109.887C98.1385 108.449 101.015 108.449 102.453 109.887L189.69 185.621C191.607 187.059 191.608 189.934 190.17 191.852C189.211 192.81 187.774 193.29 186.816 193.29Z"
        fill="#129219"
      />
      <path
        d="M72.2544 141.044C71.2958 141.044 70.339 140.565 69.3803 140.085L8.5046 87.3592C6.58729 85.9212 6.58682 83.045 8.02481 81.1277C9.46279 79.2103 12.3402 79.2099 14.2575 80.6479L75.1309 133.374C77.0482 134.812 77.0486 137.688 75.6107 139.606C74.652 140.564 73.2131 141.044 72.2544 141.044Z"
        fill="#129219"
      />
      <path
        d="M126.42 141.044C124.982 141.044 124.023 140.564 123.064 139.606C121.626 137.688 121.626 134.812 123.544 133.374L184.419 80.6479C186.337 79.2099 189.212 79.2103 190.65 81.1277C192.088 83.045 192.087 85.9212 190.17 87.3592L129.297 140.085C128.817 140.565 127.858 141.044 126.42 141.044Z"
        fill="#129219"
      />
    </svg>
  );
}
